import { createTaskError } from "@planzone/dto";
import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ list, task, range, project }) =>
    present(
      repository
        .saveTask(list, task)
        .then((savedTask) =>
          repository
            .saveAllocations(savedTask, task.allocations)
            .then((allocations) => ({ ...savedTask, allocations })),
        )
        .then((savedTask) =>
          repository
            .moveKanbanTask(
              savedTask,
              range && range.min ? { uuid: range.min.uuid } : null,
            )
            .then(() => ({ list, task: savedTask, project, range })),
        )
        .catch((error) =>
          Promise.reject({
            error: { ...createTaskError, ...error },
            list,
            task,
            project,
            range,
          }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
